import React, { FC } from 'react'
import { Box, Grid } from '@mui/material'
import { FinanceSection } from './FinanceSection'
import { revenueByAsset, totalAssetsStaked, currentUnclaimedYields, claimedYields } from './FinanceTableLists'

const GridRow: FC = ({ children }) => {
  return (
    <Grid container spacing={4}>
      {children}
    </Grid>
  )
}

export const Finance: FC = () => {
  return (
    <Box>
      <GridRow>
        <Grid item xs={6}>
          <FinanceSection title={'Revenue by Asset'} data={revenueByAsset} />
        </Grid>
        <Grid item xs={6}>
          <FinanceSection title={'Total Assets Staked'} data={totalAssetsStaked} />
        </Grid>
      </GridRow>
      <GridRow>
        <Grid item xs={6}>
          <FinanceSection title={'Current Unclaimed Yields'} data={currentUnclaimedYields} />
        </Grid>
        <Grid item xs={6}>
          <FinanceSection title={'Claimed Yield'} data={claimedYields} />
        </Grid>
      </GridRow>
    </Box>
  )
}
